var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var MODAL_TYPE_DETACH = 'detach';
        var MODAL_TYPE_CONTENT = 'content';
        var MODAL_TYPE_CONTENT_ROOMS = 'content-rooms';
        var MODAL_THEME_FULL = 'theme-full';
        var MODAL_THEME_POPUP = 'theme-popup';

        var MobileModal = function () {
            function MobileModal(params) {
                _classCallCheck(this, MobileModal);

                this.elements = {
                    body: document.querySelector('body'),
                    pageContent: document.querySelector('main'),
                    modal: document.querySelector('#mobileModal'),
                    header: document.querySelector('.js-modal-header'),
                    content: document.querySelector('.js-modal-content'),
                    backdrop: document.querySelector('.js-modal-backdrop'),
                    closeBtn: document.querySelector('.js-close-modal-old'),
                    title: document.querySelector('.js-modal-header-label'),
                    controls: document.querySelector('.js-modal-header-controls')
                };
                // Селектор который вызывает показ модалки
                this.triggerSelector = params.triggerSelector ? params.triggerSelector : null;
                // Отвечает за то каким образом будет грузится контент в модалку
                this.typeContent = params.typeContent ? params.typeContent : MODAL_TYPE_DETACH;
                // ID блока в котором лежит загружаемый контент
                this.detachContentId = params.detachContentId ? params.detachContentId : null;
                // Тема модалок. На весь экран/прижатая к низу экрана
                this.theme = params.theme ? params.theme : MODAL_THEME_FULL;
                // Заголовок в модалке
                this.title = params.title ? params.title : null;
                this.modalName = params.modalName ? params.modalName : null;
                this.content = params.content ? params.content : null;

                this.afterShowModal = params.afterShowModal ? params.afterShowModal : null;

                if (!this._isInit()) {
                    return false;
                }

                this.handlers();
            }

            _createClass(MobileModal, [{
                key: "_isInit",
                value: function _isInit() {
                    switch (this.typeContent) {
                        case MODAL_TYPE_DETACH:
                            return this.detachContentId !== null;
                        case MODAL_TYPE_CONTENT:
                            return this.content !== null;
                        case MODAL_TYPE_CONTENT_ROOMS:
                            return true;
                        default:
                            return true;
                    }
                }
            }, {
                key: "handlers",
                value: function handlers() {
                    var _this = this;

                    eventDispatcher.on('click', this.triggerSelector, function () {
                        _this.showModal();
                    });

                    // Если нужно закрыть модалку то использовать это событие
                    window.eventDispatcher.addEventListener('_close-modal', function () {
                        window.eventDispatcher.dispatchEvent('beforeCloseModal', _this);
                        _this._closeModal();
                    });

                    this.elements.closeBtn.addEventListener('click', function () {
                        window.eventDispatcher.dispatchEvent('_close-modal');
                    });
                    this.elements.backdrop.addEventListener('click', function () {
                        window.eventDispatcher.dispatchEvent('_close-modal');
                    });
                }
            }, {
                key: "showModal",
                value: function showModal() {
                    if (this._isInit()) {
                        this._beforeShowModal();
                        this._showModal();
                    }
                }
            }, {
                key: "_afterShowModal",
                value: function _afterShowModal() {
                    if (typeof this.afterShowModal === 'function') {
                        return this.afterShowModal();
                    }
                }
            }, {
                key: "_beforeShowModal",
                value: function _beforeShowModal() {
                    if (this._isOpenModal()) {
                        var theme = this.elements.modal.dataset.theme;
                        this.elements.modal.classList.remove(theme);

                        this.removeContent();
                    }
                }
            }, {
                key: "_isOpenModal",
                value: function _isOpenModal() {
                    return !this.elements.modal.classList.contains('hide');
                }
            }, {
                key: "_showModal",
                value: function _showModal() {
                    this._blockContent();

                    this.elements.modal.classList.add(this.theme);

                    switch (this.typeContent) {
                        case MODAL_TYPE_DETACH:
                            this.detachContent();
                            break;
                        case MODAL_TYPE_CONTENT:
                            this.renderContent();
                            break;
                        case MODAL_TYPE_CONTENT_ROOMS:
                            this.renderContent();
                            break;
                    }

                    if (this.theme === MODAL_THEME_POPUP && !this.title) {
                        this.elements.header.classList.add('hide');
                    }

                    this.elements.modal.dataset.detachId = this.detachContentId;
                    this.elements.modal.dataset.typeContent = this.typeContent;
                    this.elements.modal.dataset.theme = this.theme;

                    this._afterShowModal();
                }
            }, {
                key: "_closeModal",
                value: function _closeModal() {
                    this._unBlockContent();

                    this.elements.modal.classList.remove(this.theme);

                    this.removeContent();

                    if (this.theme === MODAL_THEME_POPUP && !this.title) {
                        this.elements.header.classList.remove('hide');
                    }
                }
            }, {
                key: "_blockContent",
                value: function _blockContent() {
                    this.elements.body.classList.add('modal-open');
                    this.elements.pageContent.classList.add('blur');
                }
            }, {
                key: "_unBlockContent",
                value: function _unBlockContent() {
                    this.elements.body.classList.remove('modal-open');
                    this.elements.pageContent.classList.remove('blur');
                }
            }, {
                key: "detachContent",
                value: function detachContent() {
                    var element = document.getElementById(this.detachContentId);

                    while (element.childNodes.length > 0) {
                        this.elements.content.appendChild(element.childNodes[0]);
                    }

                    this.elements.modal.classList.remove('hide');

                    this.elements.title.innerHTML = this.title;

                    this.elements.content.dataset.id = this.detachContentId;
                }
            }, {
                key: "removeContent",
                value: function removeContent() {
                    if (this.elements.content.dataset.id) {
                        var element = document.getElementById(this.elements.content.dataset.id);

                        if (element) {
                            while (this.elements.content.childNodes.length > 0) {
                                element.appendChild(this.elements.content.childNodes[0]);
                            }
                        }

                        this.elements.modal.classList.add('hide');
                        this.elements.content.innerHTML = '';
                        this.elements.content.dataset.id = '';
                    }
                }
            }, {
                key: "renderContent",
                value: function renderContent() {
                    this.elements.modal.classList.remove('hide');
                    this.elements.content.innerHTML = this.content;
                    this.elements.title.innerHTML = this.title;
                    this.elements.content.dataset.id = this.detachContentId;
                }
            }]);

            return MobileModal;
        }();

        window.MobileModal = MobileModal;
    }, {}] }, {}, [1]);